import { DatePicker, Flex, Typography } from 'antd'
import { Dayjs } from 'dayjs'
import { FC } from 'react'
import styled from 'styled-components'
import SummaryStatCard from '../../printer-content/components/summary-stat-card'
import { MANAGER_SUMMARY_LABELS } from '../constants/manager-summary-labels'
import useManagerShipments from '../hooks/use-manager-shipments'
import ShipmentsTable from './shipments-table'

const SectionTitle = styled(Typography.Title)`
    margin-top: 0 !important;
    margin-bottom: 16px !important;
`

const StatsColumn = styled(Flex)`
    flex: 0 0 220px;
    min-width: 220px;
`

const TableColumn = styled.div`
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
`

const MonthPickerRow = styled(Flex)`
    margin-bottom: 16px;
`

interface ManagerMonthlySummaryProps {
    month: Dayjs
    onMonthChange: (month: Dayjs) => void
}

const ManagerMonthlySummary: FC<ManagerMonthlySummaryProps> = ({ month, onMonthChange }) => {
    const { rows, isLoading, stats } = useManagerShipments(month)

    return (
        <div>
            <SectionTitle level={4}>Сводка за месяц</SectionTitle>

            <MonthPickerRow align='center' gap={12}>
                <Typography.Text style={{ width: 60 }}>Месяц:</Typography.Text>
                <DatePicker
                    picker='month'
                    value={month}
                    onChange={value => value && onMonthChange(value)}
                    allowClear={false}
                    style={{ width: 140 }}
                />
            </MonthPickerRow>

            <Flex gap={24} align='stretch'>
                <StatsColumn vertical gap={8}>
                    <SummaryStatCard
                        label={MANAGER_SUMMARY_LABELS.commission}
                        value={stats.commission}
                        tone={stats.commissionTone}
                    />
                    <SummaryStatCard
                        label={MANAGER_SUMMARY_LABELS.shipmentCount}
                        value={stats.shipmentCount}
                    />
                </StatsColumn>

                <TableColumn>
                    <ShipmentsTable rows={rows} isLoading={isLoading} />
                </TableColumn>
            </Flex>
        </div>
    )
}

export default ManagerMonthlySummary
